import { call, put, select } from "redux-saga/effects";
import { actions } from '@/reducers/devices';
import { getCurrentStepperInfo } from './normalizer';
import { normalizePrice } from './utils';
import { API_ERRORS } from "./constants";
const contextStore = (state) => state.main.context;

export const formatDateLong = (strDate) => {
   const date = new Date(strDate);
  
   const day = addZero(date.getDate());
   const month = addZero(date.getMonth() + 1);
   const year = date.getFullYear();

   return `${day}/${month}/${year}`;
}

const addZero = (value) => {
  return value < 10 ? '0' + value : value;

}

export function* getTransaction({payload}) {
  const getTransactionPromise = yield call(() => import('@/services/tradeIn/transaction'));
  const contextApi = yield select(contextStore);
  try {
    const { data } = payload;
    const response = yield call(getTransactionPromise.default, {
      context: contextApi,
      transactionId: data,
    });

    if(response){
      const {
        uuid,
        event,
        final_grade,
        init_grade_max, 
        init_transaction_obj,
        final_transaction_obj
      } = response;
      let Modelo, Precio_Final, Precio_Inicial, Miniatura;
      if (final_transaction_obj) {
        ({ Modelo, Precio_Final, Precio_Inicial, Miniatura } = final_transaction_obj);
      } else {
        ({ Modelo, Precio_Final, Precio_Inicial, Miniatura } = init_transaction_obj);
      }
      const price = normalizePrice(Precio_Final, 2) || normalizePrice(Precio_Inicial, 2)
      const currentStepper = getCurrentStepperInfo(event);
      const transactionToReturn = {
        ...currentStepper,
        imgUrl: Miniatura,
        model: Modelo,
        price: `${price}€`,
        co: uuid,
        finalGrade: final_grade || init_grade_max,
      };
      yield put(
        actions.setTransaction(transactionToReturn)
      );
    }
  } catch (e) {
    console.log('Error transaction', e)
    const error = buildError(e);

    yield put(
      actions.setTransactionError(error)
    );
  }
}

const buildError = (error) => {
  const { statusCode } = error;
  return (statusCode && API_ERRORS[statusCode]) || API_ERRORS.default
}
